import React, { useEffect } from 'react';
import "./style.css";
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getLocalStorage } from '../../utils/localStorage';
import { FaListOl } from 'react-icons/fa';
import { BsListNested } from 'react-icons/bs';
import lockImg from "../../data/lock.png";


function ProccessAdminPlatformMainNewScreen(props) {
    const { pathname } = useLocation();
    const { role, email } = getLocalStorage("CURRENT_USER");
      useEffect(()=>{
            localStorage.removeItem("screenCacheallLeads")
        },[])
    const RestrictedPage = () => {
        const navigate = useNavigate();
        useEffect(() => {
            setTimeout(() => {
                navigate(-1)
            }, 2000);
        }, [])

        return (<>
            <div className="restrcited-page" >
                <div className="restrcited-page-inner">
                    <div className="restrcited-page-img" >
                        <img src={lockImg} style={{ height: 125, width: 125 }} alt="restrictedpage" />
                    </div>
                    <p className="restrcited-page-p">You don't have permission to view this page</p>
                </div>
            </div>
        </>)
    }


    const CheckPermission = () => {
        const { role } = getLocalStorage("CURRENT_USER");
        const links = [

            {
                title: 'Process Admin',
                links: [
                    // { name: '', path: '/home/processRecordPlatformAllocation/tdfUsers', icon: <FiUsers />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                    // { name: 'All Records', path: '/home/processRecordPlatformAllocations/tdfAdminAllocToTls', icon: <BsListNested />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                    { name: 'All Records', path: '/home/processRecordPlatformAllocation/tdfAdminAllocToTl', icon: <BsListNested />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },

                    { name: 'Metadata', path: '/home/processRecordPlatformAllocation/tdfAdminAllocFileIdToTl', icon: <FaListOl />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                ],
                Permissions: ["ROLE_ADMIN", "ROLE_MANAGER"]
            }

        ]

        let list = [];
        for (let obj of links) {
            // Check if any role in the role array matches any permission in the Permissions array
            if (role.some(r => obj.Permissions.includes(r))) {
                let innerList = [];
                for (let key of obj.links) {
                    // Check if any role in the role array is allowed for the link
                    if (role.some(r => key.allowed.includes(r))) {
                        innerList.push(key);
                    }
                }
                let tempObj = obj;
                tempObj.links = innerList;
                list.push(tempObj);
            }
        }
        return list;
    }

    const checkActivePath = (screen) => {
        const str = pathname.split("/");
        const path = screen.split("/")
        if (
            str[0] === path[0] &&
            str[1] === path[1] &&
            str[2] === path[2] &&
            str[3] === path[3]) {
            return true;
        } else {
            return false;
        }

    }


    return (
        <>
            {email.split('@')[1] === 'theduefactory.com' ? (<>                

                <div className='ca-main-screen'>
                    <div className='ca-main-screen-head'>Platform Allocations</div>
                    <div className='ca-main-screen-head-menu'>
                        {CheckPermission().map((item) => (
                            item.links.map((link) => (
                                <NavLink
                                    to={`${link.path}`}
                                    key={link.name}
                                    className={
                                        checkActivePath(link.path)
                                            ?
                                            'ca-main-screen-head-menu-is-active ca-main-screen-head-menu-div '
                                            :
                                            'ca-main-screen-head-menu-div'
                                    }
                                >
                                    {link.icon} {link.name}
                                </NavLink>
                            ))
                        ))}

                    </div>
                    <Outlet ></Outlet>
                </div>

            </>) : (<>
                <RestrictedPage />
            </>)}
        </>
    )
}


export default ProccessAdminPlatformMainNewScreen;